module.exports = __webpack_public_path__ + "media/images/new_home/mission-bg-51b40f8d5ab0143869e85f2ca9475101.png";